// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import GoogleMapReact from 'google-map-react'

// Internal Dependencies:
import MapMarker from 'components/Map/MapMarker'
import SiteNotice from 'components/SiteNotice/SiteNotice'

// Redux:
import { setSiteId } from 'actions/schedule'

function mapOptions( maps ) {
	return {
		styles: [{ 'featureType':'administrative', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#6195a0' }] }, { 'featureType':'administrative.province', 'elementType':'geometry.stroke', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'landscape', 'elementType':'geometry', 'stylers':[{ 'lightness':'0' }, { 'saturation':'0' }, { 'color':'#f5f5f2' }, { 'gamma':'1' }] }, { 'featureType':'landscape.man_made', 'elementType':'all', 'stylers':[{ 'lightness':'-3' }, { 'gamma':'1.00' }] }, { 'featureType':'landscape.natural.terrain', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi.park', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#bae5ce' }, { 'visibility':'on' }] }, { 'featureType':'road', 'elementType':'all', 'stylers':[{ 'saturation':-100 }, { 'lightness':45 }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#fac9a9' }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'labels.text', 'stylers':[{ 'color':'#4e4e4e' }] }, { 'featureType':'road.arterial', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#787878' }] }, { 'featureType':'road.arterial', 'elementType':'labels.icon', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'transit', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'transit.station.airport', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#0a00ff' }, { 'saturation':'-77' }, { 'gamma':'0.57' }, { 'lightness':'0' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#43321e' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#ff6c00' }, { 'lightness':'4' }, { 'gamma':'0.75' }, { 'saturation':'-68' }] }, { 'featureType':'water', 'elementType':'all', 'stylers':[{ 'color':'#eaf6f8' }, { 'visibility':'on' }] }, { 'featureType':'water', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#c7eced' }] }, { 'featureType':'water', 'elementType':'labels.text.fill', 'stylers':[{ 'lightness':'-49' }, { 'saturation':'-53' }, { 'gamma':'0.79' }] }],
		scrollwheel: false,
		gestureHandling: 'cooperative',
		fullscreenControl: false,
		zoomControl: true
	}
}

class Stations extends React.Component {
	constructor() {
		super()

		this.state = {
			showNotice: false,
			selectedStation: false
		}
	}

	handleStationClick = ( e ) => {
		const id = e.currentTarget.getAttribute( 'data-id' )
		const { stationsById } = this.props
		const selectedStation = stationsById[ id ]

		if ( ! selectedStation ) {
			return
		}

		this.setState( {
			showNotice: true,
			selectedStationId: id,
			selectedStation
		} )
	}

	handleCancelNotice = () => {
		this.setState( {
			showNotice: false,
			selectedStationId: false,
			selectedStation: false
		} )
	}

	handleSetStation = () => {
		const { dispatch } = this.props
		const { selectedStationId, selectedStation } = this.state

		dispatch( setSiteId( selectedStationId, selectedStation.timezone ) )
		this.handleCancelNotice()
	}

	render() {
		const { stationsById, siteId, page } = this.props
		const { showNotice, selectedStation } = this.state
		let markersMarkup = [],
			listMarkup = {
				'ACT': [],
				'NSW': [],
				'NT': [],
				'QLD': [],
				'SA': [],
				'TAS': [],
				'VIC': [],
				'WA': [],
				'NZ': [],
			}

		if ( stationsById ) {
			markersMarkup = Object.keys( stationsById ).map( ( key ) => {
				let item = stationsById[ key ],
					name = item.name,
					freq = item.freq_fm

				if ( 'vast' === item.group ) {
					name = 'Outback Australia'
					freq = 'VAST Radio Ch 688'
				}

				return (
					<MapMarker
						key={ key }
						lat={ item.lat }
						lng={ item.lng }
						title={ name }
						freq={ freq }
						group={ item.group }
						isSelected={ false }
						onClick={ this.handleStationClick }
						id={ key }
					/>
				)
			})

			let stationsSorted = Object.keys( stationsById ).map( ( key ) => {
				return {
					key,
					...stationsById[ key ]
				}
			})

			// Add extra places:
			Object.keys( stationsById ).map( ( key ) => {
				let item = stationsById[ key ]

				if ( item.places && item.places.length > 0 ) {
					item.places.map( placeItem => {
						stationsSorted.push( {
							...placeItem, // Only contains name.
							state: item.state,
							freq_fm: item.freq_fm,
							key
						} )
					})
				}
			})

			stationsSorted.sort( ( a, b ) => {
			    if ( a.name < b.name ) {
			    	return -1
			    }

			    if ( a.name > b.name ) {
			    	return 1
			    }

			    return 0
			})

			stationsSorted.map( ( item ) => {
				let name = item.name,
					freq = item.freq_fm,
					className = '-item',
					icon

				if ( siteId == item.key ) {
					className += ' is-active'
					icon = <i class="icon-radio-waves" aria-hidden="true" />
				}

				if ( 'vast' === item.group ) {
					name = 'Outback Australia'
					freq = 'VAST Radio Ch 688'

					listMarkup['NT'].push(
						<button className={ className } onClick={ this.handleStationClick } data-id={ item.key } key={ name }>
							<div className="-name">{ name }</div>
							<div className="-freq">{ icon }{ freq }</div>
						</button>
					)
				}

				if ( item.state ) {
					if ( '7VFM' == freq ) {
						listMarkup[ item.state ].push(
							<button className={ className } onClick={ this.handleStationClick } data-id={ item.key } key={ name }>
								<div className="-name">{ name }</div>

								<div className="-freq">{ icon }{ freq }</div>
							</button>
						)
					} else {
						listMarkup[ item.state ].push(
							<button className={ className } onClick={ this.handleStationClick } data-id={ item.key } key={ name }>
								<div className="-name">{ name }</div>
								<div className="-freq">{ icon }{ freq }</div>
							</button>
						)
					}
				}
			})
		}

		return (
			<div className="stations-wrap">
				{ showNotice &&
					<SiteNotice
						text={ `${selectedStation.name} ${selectedStation.freq_fm}` }
						cancelText="Cancel"
						handleCancel={ this.handleCancelNotice }
					>
						<div className="-actions">
							<button onClick={ this.handleSetStation }>Set this as my station</button>
						</div>
					</SiteNotice>
				}

				<div className="-map">
					<GoogleMapReact
						bootstrapURLKeys={ {
							key: siteData.google_maps_api_key
						} }
						resetBoundsOnResize
						defaultCenter={ {
							lat: -29.2892123,
							lng: 139
						} }
						defaultZoom={ 4 }
						options={ mapOptions }
					>
						{ markersMarkup }
					</GoogleMapReact>
				</div>

				<div className="-legend">
					<div className="-item">
						<div className="-colour -group-a"></div>
						<div className="-text">88.0 FM</div>
					</div>

					<div className="-item">
						<div className="-colour -group-b"></div>
						<div className="-text">87.8 FM</div>
					</div>

					<div className="-item">
						<div className="-colour -group-c"></div>
						<div className="-text">87.6 FM</div>
					</div>

					<div className="-item">
						<div className="-colour -group-7"></div>
						<div className="-text">7VFM</div>
					</div>

					<div className="-item">
						<div className="-colour -group-vast"></div>
						<div className="-text">Outback Australia - VAST Radio Ch 688</div>
					</div>
				</div>

				{ page && !! page.content.rendered &&
					<div className="-legend-info" dangerouslySetInnerHTML={ { __html: page.content.rendered } } />
				}

				<div className="-state-links">
					<h6>Jump to state:</h6>

					<div className="-inner">
						<div><a className="button -small" href="#act">ACT</a></div>
						<div><a className="button -small" href="#nsw">NSW</a></div>
						<div><a className="button -small" href="#nt">NT</a></div>
						<div><a className="button -small" href="#qld">QLD</a></div>
						<div><a className="button -small" href="#sa">SA</a></div>
						<div><a className="button -small" href="#tas">TAS</a></div>
						<div><a className="button -small" href="#vic">VIC</a></div>
						<div><a className="button -small" href="#wa">WA</a></div>
						<div><a className="button -small" href="#nz">NZ</a></div>
					</div>
				</div>

				<div className="-list">
					{ listMarkup['ACT'].length > 0 &&
						<section id="act">
							<header>
								<h3>ACT</h3>
							</header>

							<main>
								{ listMarkup['ACT'] }
							</main>
						</section>
					}

					<section id="nsw">
						<header>
							<h3>New South Wales</h3>
						</header>

						<main>
							{ listMarkup['NSW'] }
						</main>
					</section>

					<section id="nt">
						<header>
							<h3>Northern Territory</h3>
						</header>

						<main>
							{ listMarkup['NT'] }
						</main>
					</section>

					<section id="qld">
						<header>
							<h3>Queensland</h3>
						</header>

						<main>
							{ listMarkup['QLD'] }
						</main>
					</section>

					<section id="sa">
						<header>
							<h3>South Australia</h3>
						</header>

						<main>
							{ listMarkup['SA'] }
						</main>
					</section>

					<section id="tas">
						<header>
							<h3>Tasmania</h3>
						</header>

						<main>
							{ listMarkup['TAS'] }
						</main>
					</section>

					<section id="vic">
						<header>
							<h3>Victoria</h3>
						</header>

						<main>
							{ listMarkup['VIC'] }
						</main>
					</section>

					<section id="wa">
						<header>
							<h3>Western Australia</h3>
						</header>

						<main>
							{ listMarkup['WA'] }
						</main>
					</section>

					{ listMarkup['NZ'].length > 0 &&
						<section id="nz">
							<header>
								<h3>New Zealand</h3>
							</header>

							<main>
								{ listMarkup['NZ'] }
							</main>
						</section>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		stationsById: state.schedule.stationsById,
		siteId: state.schedule.siteId,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Stations )
